import isNum from '../utilities/isNum.js';

const DO_NOT_PARSE = [
  'zip',
  'zipCode',
  'phone',
  'phoneNumber',
  'dob',
  'dateOfBirth',
  'studentId',
  'linkCode',
  // Scholarship America Program question keys
  'ApplicantId',
  'collegeGradYear',
];
const allowsParsing = (key: string) => !DO_NOT_PARSE.includes(key.split('.').slice(-1)[0]);

export default function parseAnswer(key: string, value: string): string | boolean | number {
  if (allowsParsing(key)) {
    if (key.toLowerCase().includes('ssn')) return value; // return value directly if the key contains ssn to avoid eliminating leading zeros
    if (['true', 'false'].includes(value)) return value === 'true';
    if (isNum(value)) return Number.parseFloat(value);
  }

  return value;
}
